import { useFormContext } from "react-hook-form";

import { InputText } from "@up/form";

export function StudentEmail() {
  const { register } = useFormContext();
  const KEY = "student-email";

  return <InputText registerProps={register(KEY)} type="hidden" />;
}
